/* DRIVE IQ — ASK PLACES V11 (SHADOW PREVIEW)

   Safe rollout: existing Google Places search, results, and navigation handoff

   remain unchanged. Optional read-only V10 intelligence comparison.

*/

/* ============================================================================

  DRIVE IQ — ASK PLACES PROVIDER V2

  Shopify asset: drive-iq-ask-places.js

  AUTHORITY

  - Google Places API (New) runs ONLY through Drive IQ Intelligence API.

  - No Google Places API key is exposed to Shopify / Drive Mode.

  - ASK supplies query + route-ahead centers.

  - Backend returns canonical Google businesses / POIs.

  - ASK IQ owns conversational ranking and speech.

  - Find Stops / Drive Mode remain the only route-install authority.

  ============================================================================ */

(function(window,document){

 "use strict";

 if(window.__DRIVE_IQ_ASK_PLACES_V2__){return;}

 window.__DRIVE_IQ_ASK_PLACES_V2__=true;

 var VERSION="3.4.0-v14-restroom-rescue";

 var API_BASE="https://driveiq-intelligence-api-85238371012.us-central1.run.app";

 var SEARCH_URL=API_BASE+"/v1/places/search";

// V11: observation-only. This flag NEVER changes delivered Places results.

// Disable in the console: DRIVE_IQ_ASK_PLACES.setPreviewEnabled(false)

var INTELLIGENCE_PREVIEW_URL=API_BASE+"/v1/ask/intelligence-preview";

var intelligencePreviewEnabled=true;

var intelligencePreviewToken=0;

// V12: OFF by default. Enable only for a controlled live test from the

// in-app webview console with DRIVE_IQ_ASK_PLACES.setRestroomFilterEnabled(true).

// Stored nowhere; resets to OFF on reload. No changes to navigation authority.

var restroomFilterEnabled=true;

var INTELLIGENCE_TIMEOUT_MS=2500;

 var activeToken=0;

 var LS={

   ROUTE_GEO:"diq_route_geo_v1",

   DRIVE_PAYLOAD:"diq_drive_payload_v1",

   LAST_FIX:"diq_last_gps_v1"

 };

 function clean(v){

   return String(v==null?"":v).replace(/\s+/g," ").trim();

 }

 function lower(v){

   return clean(v).toLowerCase();

 }

 function finite(v){

   return typeof v==="number"&&isFinite(v);

 }

 function safeParse(v){

   try{return JSON.parse(String(v||""));}

   catch(e){return null;}

 }

 function lsGet(k){

   try{return localStorage.getItem(k);}

   catch(e){return null;}

 }

 function pointFrom(obj){

   if(!obj){return null;}

   var lat=Number(

     obj.lat!=null?obj.lat:

     obj.latitude

   );

   var lng=Number(

     obj.lng!=null?obj.lng:

     (obj.lon!=null?obj.lon:obj.longitude)

   );

   if(!finite(lat)||!finite(lng)){return null;}

   return {lat:lat,lng:lng};

 }

 function milesBetween(aLat,aLng,bLat,bLng){

   var R=3958.7613;

   var lat1=Number(aLat)*Math.PI/180;

   var lat2=Number(bLat)*Math.PI/180;

   var dLat=(Number(bLat)-Number(aLat))*Math.PI/180;

   var dLng=(Number(bLng)-Number(aLng))*Math.PI/180;

   var x=

     Math.sin(dLat/2)*Math.sin(dLat/2)+

     Math.cos(lat1)*Math.cos(lat2)*

     Math.sin(dLng/2)*Math.sin(dLng/2);

   return R*2*Math.atan2(

     Math.sqrt(x),

     Math.sqrt(1-x)

   );

 }

 function getFix(){

   var value;

   try{

     if(

       window.DRIVE_IQ_DRIVE_MODE&&

       typeof window.DRIVE_IQ_DRIVE_MODE.getFix==="function"

     ){

       value=pointFrom(window.DRIVE_IQ_DRIVE_MODE.getFix());

       if(value){return value;}

     }

   }catch(e0){}

   return pointFrom(

     safeParse(lsGet(LS.LAST_FIX))

   );

 }

 function getRouteGeo(){

   var value;

   try{

     if(

       window.DRIVE_IQ_DRIVE_MODE&&

       typeof window.DRIVE_IQ_DRIVE_MODE.getRoute==="function"

     ){

       value=window.DRIVE_IQ_DRIVE_MODE.getRoute();

       if(

         value&&

         value.features&&

         value.features.length

       ){

         return value;

       }

     }

   }catch(e0){}

   value=safeParse(lsGet(LS.DRIVE_PAYLOAD));

   if(

     value&&

     value.route&&

     value.route.features&&

     value.route.features.length

   ){

     return value.route;

   }

   value=safeParse(lsGet(LS.ROUTE_GEO));

   if(

     value&&

     value.features&&

     value.features.length

   ){

     return value;

   }

   return null;

 }

 function flattenCoords(value,out){

   var i;

   out=out||[];

   if(!value){return out;}

   if(

     Object.prototype.toString.call(value)==="[object Array]"

   ){

     if(

       value.length>=2&&

       finite(Number(value[0]))&&

       finite(Number(value[1]))

     ){

       out.push([

         Number(value[0]),

         Number(value[1])

       ]);

       return out;

     }

     for(i=0;i<value.length;i++){

       flattenCoords(value[i],out);

     }

   }

   return out;

 }

 function routeCoords(){

   var route=getRouteGeo();

   var feature;

   if(

     !route||

     !route.features||

     !route.features.length

   ){

     return [];

   }

   feature=route.features[0];

   return flattenCoords(

     feature&&feature.geometry

       ? feature.geometry.coordinates

       : null,

     []

   );

 }

 function cumulativeRoute(coords){

   var out=[];

   var total=0;

   var i;

   if(!coords.length){return out;}

   out.push({

     coord:coords[0],

     miles:0

   });

   for(i=1;i<coords.length;i++){

     total+=milesBetween(

       Number(coords[i-1][1]),

       Number(coords[i-1][0]),

       Number(coords[i][1]),

       Number(coords[i][0])

     );

     out.push({

       coord:coords[i],

       miles:total

     });

   }

   return out;

 }

 function nearestRouteIndex(cumulative,fix){

   var bestIndex=0;

   var bestDistance=999999;

   var i;

   var d;

   if(!fix||!cumulative.length){

     return 0;

   }

   for(i=0;i<cumulative.length;i++){

     d=milesBetween(

       fix.lat,

       fix.lng,

       Number(cumulative[i].coord[1]),

       Number(cumulative[i].coord[0])

     );

     if(d<bestDistance){

       bestDistance=d;

       bestIndex=i;

     }

   }

   return bestIndex;

 }

 /*

   Interstate search authority:

   Ask "near me" must still be able to discover the nearest valid restaurant

   20, 25, 45+ miles ahead when the driver is on an active route.

 */

 function routeSamplePoints(){

   var coords=routeCoords();

   var fix=getFix();

   var targets=[0,5,15,25,45,75,100];

   var out=[];

   var seen={};

   var cumulative;

   var startIndex;

   var startMiles;

   var i;

   var j;

   var target;

   var coord;

   var key;

   if(!coords.length){

     if(fix){

       return [{

         lat:fix.lat,

         lng:fix.lng,

         milesAhead:0,

         lane:"nearby"

       }];

     }

     return [];

   }

   cumulative=cumulativeRoute(coords);

   startIndex=nearestRouteIndex(cumulative,fix);

   startMiles=Number(

     cumulative[startIndex]&&

     cumulative[startIndex].miles||0

   );

   for(i=0;i<targets.length;i++){

     target=startMiles+targets[i];

     coord=null;

     for(j=startIndex;j<cumulative.length;j++){

       if(Number(cumulative[j].miles)>=target){

         coord=cumulative[j].coord;

         break;

       }

     }

     if(!coord){

       coord=cumulative[cumulative.length-1].coord;

     }

     key=

       Number(coord[1]).toFixed(4)+"|"+

       Number(coord[0]).toFixed(4);

     if(seen[key]){continue;}

     seen[key]=true;

     out.push({

       lat:Number(coord[1]),

       lng:Number(coord[0]),

       milesAhead:targets[i],

       lane:

         targets[i]===0

           ?"nearby"

           :(targets[i]<=25?"ahead":"far")

     });

   }

   return out;

 }

 function nearestRouteDistanceMiles(lat,lng){

   var coords=routeCoords();

   var best=999999;

   var step;

   var i;

   var d;

   if(

     !finite(Number(lat))||

     !finite(Number(lng))||

     !coords.length

   ){

     return null;

   }

   step=Math.max(

     1,

     Math.floor(coords.length/220)

   );

   for(i=0;i<coords.length;i+=step){

     d=milesBetween(

       Number(lat),

       Number(lng),

       Number(coords[i][1]),

       Number(coords[i][0])

     );

     if(d<best){

       best=d;

     }

   }

   return best<999999?best:null;

 }

  /* V30 route-position authority. All distances are measured along the

     existing route geometry; not a routing ETA or driving detour estimate. */

  function routeProjection(point,cumulative){

    if(!point||!cumulative||cumulative.length<2){return null;}

    var best=null;

    var cos=Math.max(0.01,Math.cos(Number(point.lat)*Math.PI/180));

    for(var i=0;i<cumulative.length-1;i++){

      var a=cumulative[i].coord,b=cumulative[i+1].coord;

      var dx=(b[0]-a[0])*cos,dy=b[1]-a[1];

      var px=(point.lng-a[0])*cos,py=point.lat-a[1];

      var denominator=dx*dx+dy*dy;

      var t=denominator>0?Math.max(0,Math.min(1,(px*dx+py*dy)/denominator)):0;

      var lat=a[1]+(b[1]-a[1])*t,lng=a[0]+(b[0]-a[0])*t;

      var away=milesBetween(point.lat,point.lng,lat,lng);

      if(!best||away<best.offRouteMiles){

        best={

          offRouteMiles:away,

          alongMiles:cumulative[i].miles+

            (cumulative[i+1].miles-cumulative[i].miles)*t,

          segmentIndex:i

        };

      }

    }

    return best;

  }

  function routePositionContext(){

    var fix=getFix(),coords=routeCoords();

    if(!fix||coords.length<2){return null;}

    var cumulative=cumulativeRoute(coords);

    var driver=routeProjection(fix,cumulative);

    /* If the saved GPS is substantially off the selected route, do not

       mislabel businesses as ahead or behind. */

    if(!driver||driver.offRouteMiles>0.75){return null;}

    return {cumulative:cumulative,driver:driver};

  }

  function describePlaceOnRoute(lat,lng,routeContext){

    if(!routeContext||!finite(lat)||!finite(lng)){return null;}

    var result=routeProjection({lat:lat,lng:lng},routeContext.cumulative);

    if(!result){return null;}

    var delta=result.alongMiles-routeContext.driver.alongMiles;

    var closeToCorridor=result.offRouteMiles<=1.5;

    /* A nearest route projection can be ambiguous at loops/crossings. The

       labels are conservative and only describe the route position. */

    return {

      offsetMiles:result.offRouteMiles,

      milesAhead:delta,

      position:!closeToCorridor?"off_route":delta < -0.30?"behind":delta > 0.30?"ahead":"near_route",

      alongRoute:closeToCorridor

    };

  }

 function distanceFromFix(lat,lng){

   var fix=getFix();

   if(

     !fix||

     !finite(Number(lat))||

     !finite(Number(lng))

   ){

     return null;

   }

   return milesBetween(

     fix.lat,

     fix.lng,

     Number(lat),

     Number(lng)

   );

 }

 function queryFromRequest(detail){

   var raw=clean(detail&&detail.query);

   var q=lower(raw);

   var intent=detail&&detail.intent

     ? detail.intent

     : {};

   var named=clean(intent.namedPlace);

   /*

     Exact business identity always wins over category expansion.

     This is critical for requests such as "Find Pizza Hut near me":

     sending "pizza restaurant" to Google can omit the closest Pizza Hut.

   */

   if(named){return named;}

   if(/\bpizza hut\b/.test(q)){return "Pizza Hut";}

   if(/\bdomino'?s\b/.test(q)){return "Domino's";}

   if(/\bpapa john'?s\b/.test(q)){return "Papa John's";}

   if(/\blittle caesars\b/.test(q)){return "Little Caesars";}

   if(/\bmexican|taqueria|burrito|taco\b/.test(q)){

     return "Mexican restaurant";

   }

   if(/\bpizza|pizzeria\b/.test(q)){

     return "pizza restaurant";

   }

   if(/\bsushi|japanese\b/.test(q)){

     return "sushi restaurant";

   }

   if(/\bchinese\b/.test(q)){

     return "Chinese restaurant";

   }

   if(/\bitalian\b/.test(q)){

     return "Italian restaurant";

   }

   if(/\bbbq|barbecue\b/.test(q)){

     return "barbecue restaurant";

   }

   if(/\bsteak|steakhouse\b/.test(q)){

     return "steakhouse";

   }

   if(/\bseafood\b/.test(q)){

     return "seafood restaurant";

   }

   if(/\bburger|hamburger\b/.test(q)){

     return "burger restaurant";

   }

   if(/\bchicken|wings|wing\b/.test(q)){

     return "chicken restaurant";

   }

   if(/\bcoffee|cafe|espresso|latte\b/.test(q)){

     return "coffee shop";

   }

   if(/\bgas|fuel|gasoline\b/.test(q)){

     return "gas station";

   }

   if(/\bhotel|motel|lodging\b/.test(q)){

     return "hotel";

   }

   if(/\bgrocery|groceries|supermarket\b/.test(q)){

     return "grocery store";

   }

   return raw||"restaurant";

 }

 function nearbyTypeFromRequest(detail){

   var q=lower(detail&&detail.query);

   var intent=detail&&detail.intent?detail.intent:{};

   /*

     Named-business searches stay on Text Search so Google can resolve exact

     identity. Generic "near me" categories use Nearby Search ranked by

     physical distance from the live GPS fix.

   */

   if(clean(intent.namedPlace)){return "";}

   if(/\bpizza|pizzeria\b/.test(q)){return "restaurant";}

   if(/\bmexican|taqueria|burrito|taco\b/.test(q)){return "restaurant";}

   if(/\bsushi|japanese\b/.test(q)){return "restaurant";}

   if(/\bchinese\b/.test(q)){return "restaurant";}

   if(/\bitalian\b/.test(q)){return "restaurant";}

   if(/\bbbq|barbecue\b/.test(q)){return "restaurant";}

   if(/\bsteak|steakhouse\b/.test(q)){return "restaurant";}

   if(/\bseafood\b/.test(q)){return "restaurant";}

   if(/\bburger|hamburger\b/.test(q)){return "restaurant";}

   if(/\bcoffee|cafe|espresso|latte\b/.test(q)){return "coffee_shop";}

   if(/\bgas|fuel|gasoline\b/.test(q)){return "gas_station";}

   if(/\bhotel|motel|lodging\b/.test(q)){return "hotel";}

   if(/\bgrocery|groceries|supermarket\b/.test(q)){return "supermarket";}

   if(/\brestaurant|food|eat|dinner|lunch|breakfast\b/.test(q)){return "restaurant";}

   return "";

 }

 function normalizedBackendPlace(place,routeContext){

   var lat=Number(

     place&&place.lat!=null

       ? place.lat

       : place&&place.location

         ? place.location.latitude

         : NaN

   );

   var lng=Number(

     place&&place.lng!=null

       ? place.lng

       : place&&place.location

         ? place.location.longitude

         : NaN

   );

   var routeDistance=

     finite(lat)&&finite(lng)

       ? nearestRouteDistanceMiles(lat,lng)

       : null;

   var distance=

     finite(lat)&&finite(lng)

       ? distanceFromFix(lat,lng)

       : null;

   var rating=Number(place&&place.rating);

   var reviews=Number(

     place&&(

       place.userRatingCount!=null

         ? place.userRatingCount

         : place.reviewCount

     )

   );

  var measured=describePlaceOnRoute(lat,lng,routeContext);

  var alongRoute=measured

    ? !!(measured.alongRoute&&measured.position!=="behind")

    : (routeDistance!==null&&routeDistance<=1.5);

  var actualAhead=!!(measured&&measured.position==="ahead");

   return {

     id:clean(

       place&&(

         place.googlePlaceId||

         place.placeId||

         place.id

       )

     ),

     placeId:clean(

       place&&(

         place.googlePlaceId||

         place.placeId||

         place.id

       )

     ),

     googlePlaceId:clean(

       place&&(

         place.googlePlaceId||

         place.placeId||

         place.id

       )

     ),

     name:clean(

       place&&(

         place.name||

         place.displayName

       )

     ),

     label:clean(

       place&&(

         place.name||

         place.displayName

       )

     ),

     address:clean(

       place&&(

         place.formattedAddress||

         place.shortFormattedAddress

       )

     ),

     formattedAddress:clean(

       place&&place.formattedAddress

     ),

     lat:finite(lat)?lat:null,

     lng:finite(lng)?lng:null,

     types:

       place&&

       Object.prototype.toString.call(place.types)==="[object Array]"

         ? place.types.slice()

         : [],

     primaryType:clean(

       place&&place.primaryType

     ),

     category:clean(

       place&&place.primaryTypeDisplayName

     ),

     rating:

       finite(rating)

         ? rating

         : null,

     reviewCount:

       finite(reviews)

         ? reviews

         : null,

     userRatingCount:

       finite(reviews)

         ? reviews

         : null,

     isOpen:

       place&&

       typeof place.openNow==="boolean"

         ? place.openNow

         : null,

     openNow:

       place&&

       typeof place.openNow==="boolean"

         ? place.openNow

         : null,

     businessStatus:clean(

       place&&place.businessStatus

     ),

     googleMapsUri:clean(

       place&&place.googleMapsUri

     ),

     websiteUri:clean(

       place&&place.websiteUri

     ),

     phone:clean(

       place&&(

         place.nationalPhoneNumber||

         place.internationalPhoneNumber

       )

     ),

     editorialSummary:clean(

       place&&place.editorialSummary

     ),

     photos:

       place&&

       Object.prototype.toString.call(place.photos)==="[object Array]"

         ? place.photos.slice()

         : [],

     distanceMiles:

       distance!==null

         ? distance

         : null,

     distMiles:

       distance!==null

         ? distance

         : null,

     routeDistMiles:

       routeDistance!==null

         ? routeDistance

         : null,

    isAlongRoute:alongRoute,

    routeAheadPractical:actualAhead&&alongRoute,

    routePosition:measured?measured.position:"unknown",

    routeAheadMiles:actualAhead?Math.max(0,measured.milesAhead):null,

    routeLateralMiles:measured?measured.offsetMiles:null,

    routeDistanceEstimated:!!measured,

     provider:"google_places_new",

     source:"driveiq_intelligence_api",

     sourceProvider:"google_places_new",

     identityAuthority:"google-place-id",

     inventoryAuthority:"google-places-new"

   };

 }

 function buildBody(detail,mode){

   var points=routeSamplePoints();

   var centers=[];

   var fix=getFix();

   var scope=

     detail&&detail.intent

       ? clean(detail.intent.locationScope)

       : "auto";

   var i;

   /*

     Near-me searches get a dedicated first pass centered ONLY on the live

     vehicle. This gives Google the full candidate budget around the driver

     instead of splitting that budget across route-ahead sample points.

   */

   if(mode==="nearby-first" && fix){

     centers.push({

       latitude:fix.lat,

       longitude:fix.lng

     });

   }else{

     for(i=0;i<points.length;i++){

       centers.push({

         latitude:Number(points[i].lat),

         longitude:Number(points[i].lng)

       });

     }

   }

   return {

     requestId:clean(detail&&detail.requestId),

     query:queryFromRequest(detail),

     originalQuery:clean(detail&&detail.query),

     centers:centers,

     currentLocation:fix

       ? {

           latitude:fix.lat,

           longitude:fix.lng

         }

       : null,

     radiusMeters:

       mode==="nearby-first"

         ? 8000

         : 18000,

     maxResults:

       mode==="nearby-first"

         ? 20

         : 40,

     scope:scope,

     searchMode:mode||"corridor",

     nearbyType:

       mode==="nearby-first"

         ? nearbyTypeFromRequest(detail)

         : ""

   };

 }

 function deliver(detail,items,meta){

   if(

     !window.DRIVE_IQ_ASK||

     typeof window.DRIVE_IQ_ASK.receiveResults!=="function"

   ){

     return;

   }

   window.DRIVE_IQ_ASK.receiveResults(

     items||[],

     {

       requestId:clean(detail&&detail.requestId),

       source:"driveiq_intelligence_api",

       provider:"google_places_new",

       backend:API_BASE,

       query:queryFromRequest(detail),

       status:meta&&meta.status||"ok",

       error:meta&&meta.error||null

     }

   );

 }

 function fetchSearchBody(body){

   return fetch(SEARCH_URL,{

     method:"POST",

     credentials:"omit",

     cache:"no-store",

     headers:{

       "Content-Type":"application/json"

     },

     body:JSON.stringify(body)

   })

     .then(function(response){

       return response.text().then(function(text){

         var payload=null;

         try{

           payload=text

             ? JSON.parse(text)

             : null;

         }catch(e0){

           payload=null;

         }

         if(!response.ok){

           var errorCode=

             payload&&payload.error

               ? payload.error

               : "HTTP_"+String(response.status);

           throw new Error(errorCode);

         }

         return payload||{};

       });

     });

 }

  function normalizePayloadPlaces(payload,detail){

   var raw=

     payload&&

     Object.prototype.toString.call(payload.places)==="[object Array]"

       ? payload.places

       : [];

   var items=[];

   var i;

   var routeContext=routePositionContext();

   var scope=clean(detail&&detail.intent&&detail.intent.locationScope||"auto");

   var keepNearby=scope==="nearby";

   for(i=0;i<raw.length;i++){

     var place=normalizedBackendPlace(raw[i],routeContext);

     if(!finite(place.lat)||!finite(place.lng)||!place.name){continue;}

     if(!keepNearby&&routeContext&&place.routePosition==="behind"){continue;}

     if(scope==="route"&&routeContext&&place.routePosition==="off_route"){continue;}

     if(scope==="route"&&place.routeAheadMiles!==null){

       place.distanceMiles=place.routeAheadMiles;

       place.distMiles=place.routeAheadMiles;

       place.distanceBasis="route_progress";

     }else{

       place.distanceBasis="straight_line";

     }

     items.push(place);

   }

   return items;

 }

 /* --------------------------------------------------------------------------

   V11 — ASK Intelligence SHADOW PREVIEW

   - Evaluate the SAME real Places candidates the user received.

   - Never change result arrays, sorting, speech, or navigation.

   - Only restroom requests (the validated V10 policy) are sampled.

   - No persistent conversation storage or API keys on this client.

   - Exposes lastPreview for development inspection; stale responses ignored.

--------------------------------------------------------------------------- */

function requestIsRestroom(detail){

  var q=lower(detail&&detail.query);

  var category=lower(detail&&detail.intent&&detail.intent.category);

  return category==="restroom" || /\b(restroom|bathroom|toilet|public washroom)\b/.test(q);

}

function intelligenceRequestBody(detail,items){

  return {query:clean(detail&&detail.query),

    places:items.slice(0,30).map(function(place){

      return {id:clean(place.googlePlaceId||place.placeId||place.id),

        name:clean(place.name),

        types:Array.isArray(place.types)?place.types.slice(0,30):[],

        primaryType:clean(place.primaryType),

        businessStatus:clean(place.businessStatus),

        distanceMiles:typeof place.distanceMiles==="number"?place.distanceMiles:null,

        routeAheadMiles:typeof place.routeAheadMiles==="number"?place.routeAheadMiles:null,

        routePosition:clean(place.routePosition)};

    })};

}

function callIntelligencePreview(detail,items,token){

  var previewToken=++intelligencePreviewToken;

  var requestId=clean(detail&&detail.requestId);

  var body=intelligenceRequestBody(detail,items);

  var controller=typeof AbortController==="function"?new AbortController():null;

  var timeout=window.setTimeout(function(){if(controller){controller.abort();}},INTELLIGENCE_TIMEOUT_MS);

  window.DRIVE_IQ_ASK_PLACES.lastPreview={requestId:requestId,status:"pending",evaluated:body.places.length};

  return fetch(INTELLIGENCE_PREVIEW_URL,{

    method:"POST",credentials:"omit",cache:"no-store",

    headers:{"Content-Type":"application/json"},

    signal:controller?controller.signal:undefined,

    body:JSON.stringify(body)

  }).then(function(response){

    if(!response.ok){throw new Error("PREVIEW_HTTP_"+response.status);}

    return response.json();

  }).then(function(data){

    if(token!==activeToken||previewToken!==intelligencePreviewToken){return null;}

    if(!data||data.ok!==true||!Array.isArray(data.approved)||!Array.isArray(data.withheld)){

      throw new Error("PREVIEW_INVALID_RESPONSE");

    }

    window.DRIVE_IQ_ASK_PLACES.lastPreview={

      requestId:requestId,status:"ok",evaluated:body.places.length,

      approved:data.approved,withheld:data.withheld,

      nextStep:data.nextStep||null,previewOnly:!restroomFilterEnabled,

      liveResultsUnchanged:!restroomFilterEnabled

    };

    try{window.dispatchEvent(new CustomEvent("driveiq:ask-intelligence-preview",{detail:window.DRIVE_IQ_ASK_PLACES.lastPreview}));}catch(e){}

    return data;

  }).finally(function(){window.clearTimeout(timeout);});

}

function runIntelligencePreview(detail,items,token){

  if(!intelligencePreviewEnabled||!requestIsRestroom(detail)||!items||!items.length){return;}

  callIntelligencePreview(detail,items,token).catch(function(error){

    if(token!==activeToken){return;}

    window.DRIVE_IQ_ASK_PLACES.lastPreview={status:"unavailable",

      error:clean(error&&error.message||error),liveResultsUnchanged:true};

  });

}

function evaluatedRestroomResults(detail,items,token){

  if(!restroomFilterEnabled||!requestIsRestroom(detail)||!items.length){

    runIntelligencePreview(detail,items,token);

    return Promise.resolve(items);

  }

  return callIntelligencePreview(detail,items,token).then(function(data){

    if(token!==activeToken||!data){return [];}

    var approvedIds={};

    data.approved.forEach(function(row){approvedIds[String(row.placeId||"")]=true;});

    var filtered=items.filter(function(place){

      return !!approvedIds[clean(place.googlePlaceId||place.placeId||place.id)];

    });

    // Distance basis is explicit: near me = straight line, active route =

    // along-route progress when available. Never claim actual driving ETA.

    var nearby=lower(detail&&detail.intent&&detail.intent.locationScope)==="nearby";

    filtered.sort(function(a,b){

      function distance(p){

        if(!nearby&&typeof p.routeAheadMiles==="number"&&p.routeAheadMiles>=0){return p.routeAheadMiles;}

        return typeof p.distanceMiles==="number"?p.distanceMiles:1e6;

      }

      var da=distance(a),db=distance(b);

      return da===db?0:da-db;

    });

    window.DRIVE_IQ_ASK_PLACES.lastFilter={mode:"restroom_only",approved:filtered.length,

      withheld:items.length-filtered.length,requestId:clean(detail&&detail.requestId)};

    return filtered;

  }).catch(function(error){

    if(token!==activeToken){return [];}

    window.DRIVE_IQ_ASK_PLACES.lastFilter={mode:"fallback_unfiltered_on_error",

      error:clean(error&&error.message||error)};

    // Availability fallback preserves the currently working ASK IQ behavior.

    // Do not call this "validated"; it was not evaluated.

    return items;

  });

}

function search(detail){

   var token=++activeToken;

   var scope=

     detail&&detail.intent

       ? clean(detail.intent.locationScope)

       : "auto";

   var nearbyCandidate=

     scope==="nearby"

       ? buildBody(detail,"nearby-first")

       : null;

   var nearbyBody=

     nearbyCandidate&&nearbyCandidate.nearbyType

       ? nearbyCandidate

       : null;

   var corridorBody=buildBody(detail,"corridor");

   // V14: controlled secondary discovery using the existing Google Places endpoint.
   // No new APIs, no keys in Shopify, no navigation changes.
   function rescueRestroomSearch(request,token,prior){
     var searches=["travel center","rest area","truck stop"];
     var tried={};
     (prior||[]).forEach(function(p){var id=clean(p.googlePlaceId||p.placeId||p.id);if(id){tried[id]=true;}});
     var attempts=[];
     function run(index){
       if(token!==activeToken){return Promise.resolve([]);}
       if(index>=searches.length){
         window.DRIVE_IQ_ASK_PLACES.lastRescue={status:"no_suitable_candidates",attempts:attempts};
         return Promise.resolve([]);
       }
       var body=buildBody(request,"corridor");
       body.query=searches[index];
       body.maxResults=40;
       return fetchSearchBody(body).then(function(payload){
         if(token!==activeToken){return [];}
         var rows=normalizePayloadPlaces(payload,request).filter(function(p){
           var id=clean(p.googlePlaceId||p.placeId||p.id);
           if(!id||tried[id]){return false;}
           tried[id]=true;
           return true;
         });
         attempts.push({query:body.query,candidates:rows.length});
         if(!rows.length){return run(index+1);}
         return evaluatedRestroomResults(request,rows,token).then(function(valid){
           if(token!==activeToken){return [];}
           if(valid.length){
             window.DRIVE_IQ_ASK_PLACES.lastRescue={status:"recovered",query:body.query,approved:valid.length,attempts:attempts};
             return valid;
           }
           return run(index+1);
         });
       }).catch(function(error){
         if(token!==activeToken){return [];}
         attempts.push({query:body.query,error:clean(error&&error.message||error)});
         return run(index+1);
       });
     }
     return run(0);
   }

   function finish(payload,body,mode){

     var items=normalizePayloadPlaces(payload,detail);

     if(token!==activeToken){

       return [];

     }

     window.DRIVE_IQ_ASK_PLACES.lastResponse={

       ok:true,

       count:items.length,

       query:body.query,

       provider:payload.provider||"google_places_new",

       generatedAt:payload.generatedAt||"",

       warnings:payload.warnings||[],

       searchMode:mode,

       ranking:payload.ranking||"",

       topCandidates:items.slice(0,8).map(function(place){

         return {

           name:clean(place&&place.name),

           distanceMiles:

             place&&place.distanceMiles!=null

               ? Number(place.distanceMiles)

               : null,

           rating:

             place&&place.rating!=null

               ? Number(place.rating)

               : null,

           reviewCount:

             place&&place.reviewCount!=null

               ? Number(place.reviewCount)

               : null

         };

       })

     };

    // Filter only restroom candidates; if nothing suitable remains, try targeted searches.
    // Filter only when deliberately enabled for a controlled test.

    // Normal search, route handoff, and navigation are unchanged.

    if(restroomFilterEnabled && requestIsRestroom(detail)){

      return evaluatedRestroomResults(detail,items,token).then(function(finalItems){

        if(token!==activeToken){return [];}

        // A broad Google result set can contain 30 completely unsuitable places.
        // Do NOT report no match until a restroom-specific rescue search runs.
        if(finalItems.length){
          deliver(detail,finalItems,{status:"ok"});
          return finalItems;
        }
        return rescueRestroomSearch(detail,token,items).then(function(rescued){
          if(token!==activeToken){return [];}
          deliver(detail,rescued,{status:rescued.length?"ok":"no_verified_restroom_candidates"});
          return rescued;
        });

      });

    }

    runIntelligencePreview(detail,items,token);

     deliver(detail,items,{

       status:"ok"

     });

     return items;

   }

   if(

     !corridorBody.requestId||

     !corridorBody.query||

     !corridorBody.centers.length

   ){

     deliver(detail,[],{

       status:"invalid_request",

       error:"MISSING_QUERY_OR_LOCATION"

     });

     return Promise.resolve([]);

   }

   /*

     Progressive authority:

     1. "Near me" gets a true local search around the live GPS fix.

     2. If Google finds no useful nearby inventory, expand along the route.

     This keeps interstate rescue without sacrificing obvious corner options.

   */

   if(

     nearbyBody &&

     nearbyBody.centers.length

   ){

     return fetchSearchBody(nearbyBody)

       .then(function(payload){

         var items=normalizePayloadPlaces(payload,detail);

         if(token!==activeToken){

           return [];

         }

         /*

           A single strong nearby result is enough.

           V2.4 incorrectly required TWO nearby matches before accepting the

           local pass. That caused valid one-result searches such as El Agave

           to be thrown away and replaced by a broader corridor fallback.

         */

         if(items.length>=1){

           return finish(payload,nearbyBody,"nearby-first");

         }

         return fetchSearchBody(corridorBody)

           .then(function(corridorPayload){

             return finish(

               corridorPayload,

               corridorBody,

               "corridor-fallback"

             );

           });

       })

       .catch(function(){

         return fetchSearchBody(corridorBody)

           .then(function(payload){

             return finish(

               payload,

               corridorBody,

               "corridor-fallback"

             );

           });

       })

       .catch(function(error){

         if(token!==activeToken){

           return [];

         }

         window.DRIVE_IQ_ASK_PLACES.lastResponse={

           ok:false,

           count:0,

           query:corridorBody.query,

           error:clean(

             error&&error.message

               ? error.message

               : error

           ),

           searchMode:"failed"

         };

         deliver(detail,[],{

           status:"backend_error",

           error:

             error&&error.message

               ? error.message

               : "UNKNOWN"

         });

         return [];

       });

   }

   return fetchSearchBody(corridorBody)

     .then(function(payload){

       return finish(payload,corridorBody,"corridor");

     })

     .catch(function(error){

       if(token!==activeToken){

         return [];

       }

       window.DRIVE_IQ_ASK_PLACES.lastResponse={

         ok:false,

         count:0,

         query:corridorBody.query,

         error:clean(

           error&&error.message

             ? error.message

             : error

         )

       };

       deliver(detail,[],{

         status:"backend_error",

         error:

           error&&error.message

             ? error.message

             : "UNKNOWN"

       });

       return [];

     });

 }

 function onAskSearch(event){

   var detail=

     event&&event.detail

       ? event.detail

       : {};

   /*

     This provider is now the sole ASK POI authority.

     Find Stops remains installed only for route-confirmation / waypoint handoff.

   */

   search(detail);

 }

 window.addEventListener(

   "driveiq:ask-search",

   onAskSearch,

   false

 );

 window.DRIVE_IQ_ASK_PLACES={

  setRestroomFilterEnabled:function(v){restroomFilterEnabled=(v===true);return restroomFilterEnabled;},

  getRestroomFilterEnabled:function(){return restroomFilterEnabled;},

  lastFilter:null,

   version:VERSION,

   provider:"google_places_new_backend",

   backend:API_BASE,

   endpoint:SEARCH_URL,

   search:search,

   getRouteSamplePoints:routeSamplePoints,

   previewEndpoint:INTELLIGENCE_PREVIEW_URL,

  setPreviewEnabled:function(value){

    intelligencePreviewEnabled=!!value;

    if(!intelligencePreviewEnabled){intelligencePreviewToken+=1;}

    return intelligencePreviewEnabled;

  },

  getPreviewEnabled:function(){return intelligencePreviewEnabled;},

  lastPreview:null,

  lastResponse:null

 };

})(window,document);

